import { registerLocaleData } from '@angular/common';

// Locales for Angular
import localeBg from '@angular/common/locales/bg';
import localeCs from '@angular/common/locales/cs';
import localeDa from '@angular/common/locales/da';
import localeDe from '@angular/common/locales/de';
import localeDeAt from '@angular/common/locales/de-AT';
import localeDeCh from '@angular/common/locales/de-CH';
import localeDeLu from '@angular/common/locales/de-LU';
import localeEn from '@angular/common/locales/en';
import localeEnGb from '@angular/common/locales/en-GB';
import localeEs from '@angular/common/locales/es';
import localeEt from '@angular/common/locales/et';
import localeFi from '@angular/common/locales/fi';
import localeFr from '@angular/common/locales/fr';
import localeFrBe from '@angular/common/locales/fr-BE';
import localeFrCh from '@angular/common/locales/fr-CH';
import localeFrLu from '@angular/common/locales/fr-LU';
import localeHr from '@angular/common/locales/hr';
import localeHu from '@angular/common/locales/hu';
import localeIt from '@angular/common/locales/it';
import localeItCh from '@angular/common/locales/it-CH';
import localeLt from '@angular/common/locales/lt';
import localeLv from '@angular/common/locales/lv';
import localeNb from '@angular/common/locales/nb';
import localeNl from '@angular/common/locales/nl';
import localeNlBe from '@angular/common/locales/nl-BE';
import localeNo from '@angular/common/locales/no';
import localePl from '@angular/common/locales/pl';
import localePt from '@angular/common/locales/pt';
import localeRo from '@angular/common/locales/ro';
import localeRu from '@angular/common/locales/ru';
import localeSk from '@angular/common/locales/sk';
import localeSl from '@angular/common/locales/sl';
import localeSr from '@angular/common/locales/sr';
import localeSv from '@angular/common/locales/sv';
import localeTr from '@angular/common/locales/tr';
import localeUk from '@angular/common/locales/uk';
import localeZh from '@angular/common/locales/zh';

// Locales for DayJS
import 'dayjs/locale/bg';
import 'dayjs/locale/cs';
import 'dayjs/locale/da';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/et';
import 'dayjs/locale/fi';
import 'dayjs/locale/fr';
import 'dayjs/locale/hr';
import 'dayjs/locale/hu';
import 'dayjs/locale/it';
import 'dayjs/locale/lt';
import 'dayjs/locale/lv';
import 'dayjs/locale/nb';
import 'dayjs/locale/nl';
import 'dayjs/locale/nn';
import 'dayjs/locale/pl';
import 'dayjs/locale/pt';
import 'dayjs/locale/ro';
import 'dayjs/locale/ru';
import 'dayjs/locale/sk';
import 'dayjs/locale/sl';
import 'dayjs/locale/sr';
import 'dayjs/locale/sv';
import 'dayjs/locale/tr';
import 'dayjs/locale/uk';
import 'dayjs/locale/zh';

// Registration Angular Locales
export function registerAllLocales() {
  registerLocaleData(localeBg, 'bg-BG');
  registerLocaleData(localeCs, 'cs-CZ');
  registerLocaleData(localeDa, 'da-DK');
  registerLocaleData(localeDe, 'de');
  registerLocaleData(localeDeAt, 'de-AT');
  registerLocaleData(localeDeCh, 'de-CH');
  registerLocaleData(localeDeLu, 'de-LU');
  registerLocaleData(localeEn, 'en');
  registerLocaleData(localeEnGb, 'en-GB');
  registerLocaleData(localeEs, 'es-ES');
  registerLocaleData(localeEt, 'et-EE');
  registerLocaleData(localeFi, 'fi-FI');
  registerLocaleData(localeFr, 'fr');
  registerLocaleData(localeFrBe, 'fr-BE');
  registerLocaleData(localeFrCh, 'fr-CH');
  registerLocaleData(localeFrLu, 'fr-LU');
  registerLocaleData(localeHr, 'hr-HR');
  registerLocaleData(localeHu, 'hu-HU');
  registerLocaleData(localeIt, 'it');
  registerLocaleData(localeItCh, 'it-CH');
  registerLocaleData(localeLt, 'lt-LT');
  registerLocaleData(localeLv, 'lv-LV');
  registerLocaleData(localeNl, 'nl');
  registerLocaleData(localeNlBe, 'nl-BE');
  registerLocaleData(localePl, 'pl-PL');
  registerLocaleData(localePt, 'pt-PT');
  registerLocaleData(localeRo, 'ro-RO');
  registerLocaleData(localeRu, 'ru-RU');
  registerLocaleData(localeSk, 'sk-SK');
  registerLocaleData(localeSl, 'sl-SI');
  registerLocaleData(localeSr, 'sr-RS');
  registerLocaleData(localeSv, 'sv-SE');
  registerLocaleData(localeTr, 'tr-TR');
  registerLocaleData(localeUk, 'uk-UA');
  registerLocaleData(localeZh, 'zh-CN');
  registerLocaleData(localeNb, 'nb-NO');
  registerLocaleData(localeNo, 'no-NO');
}
